import React from 'react'
function About({ data }) {
    return (
        <div id="about" className="container">
            <div className="row">
                <div className="col-xs-12 col-md-7 infos">
                    <h3>{ data.title }</h3>
                    <p>{ data.description }</p>
                </div>
                <div className="col-xs-12 col-md-5 roles">
                <img alt="Leetask" src="https://res.cloudinary.com/leetask/image/upload/v1654466329/website/assets/About_mock_cs3dmh.webp" />
                </div>
            </div>
        </div>
    )
}

export default About
